import { compose } from "recompact"
import * as entity from "src/engine/modules/entity"
import resourceTypeModel from "src/models/resourceType"
import collection from "src/hocs/collection"

export default config =>
  compose(
    collection({
      engine: entity,
      to: `resourceTypes`,
      model: resourceTypeModel,
      query: {
        limit: -1,
        orderBy: `name asc`,
      },
      ...config,
    }),
  )
